import { render } from "./SchoolRegister.vue?vue&type=template&id=24a9bd26&scoped=true"
import script from "./SchoolRegister.vue?vue&type=script&lang=js"
export * from "./SchoolRegister.vue?vue&type=script&lang=js"

import "./SchoolRegister.vue?vue&type=style&index=0&id=24a9bd26&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hagino\\work\\src\\plus-manabi\\mplus-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a9bd26"]])

export default __exports__